// extracted by mini-css-extract-plugin
export var alertDescription = "alert-description_HhokN75pl7dIj66q7V8t";